class TotalUtils {

  maptoObj(arr) {
    const obj = {};
    for(const i of arr) {
      // eslint-disable-next-line no-unused-expressions
      !obj[i]?obj[i]=1:obj[i]++;
    }
    return obj;
  }

  //if the arr has 'qid' field this will remove any duplicate
  elegantRemoveDuplicate(arr) {
    const temp = [];
    arr.forEach(({qid}) => temp.push(qid));
    const obj = this.maptoObj(temp);
    for(const i in obj) {
      if(obj[i]>1) {
        const index = arr.findIndex(({qid}) => qid === i);
        if(index > -1) {
          arr.splice(index, 1);
        }
      }
    }
    return arr;
  }

  headerBoolFlag(arr, sarr) {
    const kqids = [];
    const kbools = [];
    arr.forEach(({qid}) => kqids.push(qid));
    if(kqids.length > 0) {
      kqids.forEach(kqid => {
        const kobj = sarr.find(({qid}) => qid===kqid);
        if(kobj) {
          kbools.push(kobj.boxChecked);
        } else {
          kbools.push(false);
        }
      });
      const kflag = kbools.every(ele => ele ===true);
      if(kflag) {
        return true;
      }else {
        return false;
      }
    } else {
      return false;
    }
  }

  anyUnsavedInMap(selarr) {
    for (const major of selarr) {
      if(major.modified) {
        return true;
      }
    }
    return false;
  }

  addAllResult(modarr, selarray, actionArray) {
    const temp = modarr;
    const stemp = selarray;
    const mtemp = [...selarray];

    temp.forEach(major => {
      major.boxChecked = true;
      major.modified = true;
      const ind = stemp.findIndex(({qid}) => qid===major.qid);
      if(ind < 0) {
        mtemp.push(major);
      }
    });

    actionArray([...mtemp]);
  }

  handleSelectedTableDelete(totalArray, qid, setarray) {
    const temp = totalArray;
    temp.forEach(major => {
      if(major.qid === qid) {
        major.boxChecked = false;
        major.degrees[2]=false;major.degrees[3]=false;major.degrees[4]=false;
        major.degrees[5]=false;major.degrees[6]=false;major.degrees[7]=false;
        major.modified = true;
      }
    });
    setarray([...temp]);
  }

  onChangeHeaderBool(arr, sarr, bflag, actionarray) {
    const kqids = [];
    if(bflag) {
      arr.forEach(amaj => {
        kqids.push(amaj.qid);
        amaj.boxChecked = bflag;
        amaj.modified = true;
        sarr.push(amaj);
      });
      this.elegantRemoveDuplicate(sarr);
    }
    if(!bflag) {
      arr.forEach(({qid}) => kqids.push(qid));
      kqids.forEach(kqid => {
        sarr.forEach(smajor => {
          if(smajor.qid===kqid) {
            smajor.boxChecked = bflag;
            smajor.degrees[2]=false;smajor.degrees[3]=false;smajor.degrees[4]=false;
            smajor.degrees[5]=false;smajor.degrees[6]=false;smajor.degrees[7]=false;
            smajor.modified = true;
          }
        });
      });
    }
    actionarray([...sarr]);
  }

  majorInput(sarr, sqid) {
    const obj = sarr.find(({qid}) => sqid === qid);
    if(obj) {
      return obj.boxChecked;
    } else {
      return null;
    }
  }

  selectAllUpdate(arr, qid) {
    const temp = arr;
    temp.forEach(major => {
      if(major.boxChecked===true && qid===major.qid) {
        major.degrees[2]=true;major.degrees[3]=true;major.degrees[4]=true;
        major.degrees[5]=true;major.degrees[6]=true;major.degrees[7]=true;
        major.modified = true;
      }
    });
    //actionarray([...temp]);
  }

  updateMajorInput(sarr, marr, flag, mQID, actionArray) {
    if(flag) {
      marr.forEach(kmajor => {
        if(kmajor.qid===mQID) {
          const temp = kmajor;
          temp.boxChecked = true;
          temp.modified = true;
          const stemp = sarr.find(({qid}) => kmajor.qid===qid);

          if(!stemp) {
            actionArray([...sarr, temp]);
          }else {
            sarr.forEach(obj => {
              if(obj.qid === stemp.qid) {
                obj.boxChecked = true;
                obj.modified = true;
              }
            });
            actionArray([...sarr]);
          }
        }
      });
    }
    if(!flag) {
      sarr.forEach(major => {
        if(major.qid===mQID) {
          major.boxChecked = false;
          major.modified = true;
          major.degrees[2]=false;major.degrees[3]=false;major.degrees[4]=false;
          major.degrees[5]=false;major.degrees[6]=false;major.degrees[7]=false;
        }
      });
      actionArray([...sarr]);
    }
  }

  onlyTrueObjects(arr) {
    const temp = [];
    arr.forEach(major => {
      if(major.boxChecked) {
        temp.push(major);
      }
    });
    return this.elegantRemoveDuplicate(temp);
  }

  updateSelectedColHeader(allData, index, flag) {
    allData.forEach(major => {
      if(major.boxChecked === true) {
        major.degrees[index] = flag;
      }
      major.modified = true;
    });
  }

  updateIndividualCheck(arr, index, bool, qid) {
    arr.forEach(major => {
      if(major.qid === qid) {
        major.degrees[index] = bool;
      }
      major.modified = true;

    });
  }

  truthyCheck(arr, bool, index) {
    const trutharray=[];
    if(bool===true) {
      arr.forEach(major => {
        if(major.boxChecked===true) {
          trutharray.push(major.degrees[index]);
        }
      });
    }
    return trutharray;
  }
}

export default TotalUtils;